module.exports = __webpack_public_path__ + "img/1440.02197b46.svg";